// src/internal/components/change-password-panel/use-change-password.ts
import { useAuthContext, useAuthFetch } from "@clara/auth";
import { useAsyncFn } from "@clara/hooks";
var useChangePassword = () => {
  const { user, config } = useAuthContext();
  const request = useAuthFetch();
  const uuid = user == null ? void 0 : user.uuid;
  const state = useAsyncFn(
    async ({
      newPssw: passwd,
      currentPassword: currPassword
    }) => {
      const URL = `${config.url}${config.version === "v3" ? "/user/auth0/updatePassword/" : `/user/${uuid}`}`;
      const response = await request(URL, {
        method: "PUT",
        body: JSON.stringify({ passwd, currPassword })
      });
      return response;
    },
    [uuid, request]
  );
  return state;
};

export {
  useChangePassword
};
